<template lang="pug">
  header.header(v-if="header")
    .header__left
      .header__logo-wr
        router-link.header__logo(to="/")
          img.header__logo-img(v-if="header.logo", :src="header.logo" alt = '')
        a.header__phone(v-if="header.phone", :href="header.phone.link")
          | {{header.phone.title}}
        .header__address(v-if="header.address")
          SvgIcon.header__address-ico(name="marker", width="16", height="16")
          | {{header.address}}
        .header__time(v-if="header.time")
          SvgIcon.header__time-ico(name="clock", width="16", height="16")
          | {{header.time}}
      .header__contacts
        a.header__contacts-phone(v-if="header.phone", :href="header.phone.link")
          | {{header.phone.title}}
        .header__contacts-time(v-if="header.time")
          | {{header.time}}
    .header__right
      .header__menu(v-if="header.menu")
        router-link.header__menu-item(v-for="item in header.menu", :to="item.link", :key="item.id")
          | {{item.title}}
      router-link.header__cart(v-if="header.cart", :to="header.cart.link")
        SvgIcon.header__cart-ico(name="cart", width="32", height="32")
        .header__cart-count.header__cart-count--hide
</template>

<script>
  import '@/components/common/header/header.styl';

  import EventBus from '@/eventBus';
  //import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

  export default {
    name: 'Header',

    //mixins: [AjaxHelpersVue],

    data() {
      return {
        header: null
      }
    },

    components: {
      SvgIcon
    },

    created() {
      // Данные страницы загружены
      EventBus.$on('pageLoaded', res => {
        let path = this.$route.path || '';

        this.header = res.header;

        this.$nextTick(() => {
          this.setInitialActiveClass(path);
        });
      });

      this.$nextTick(() => {
        this.setActiveClass();
      });
    },

    methods: {
      // Смена языка
      /*setLanguage(name, value) {
        this.selectPreloaderShow = true;

        this.req('Language:setLanguage', {name, value, url: this.$route.path || ''}, res => {
          setTimeout(() => {
            // Перезагружает текущую страницу
            this.$router.go();
          }, 500);
        }, '', 'localPageRequest');
      },*/

      //
      setInitialActiveClass(path) {
        let pathArr = path.split('/');

        $('.header__menu-item').removeClass('header__menu-item--active');

        if(pathArr[1].length) {
          $(`.header__menu-item[href*='${pathArr[1]}']`).addClass('header__menu-item--active');
        } else {
          $('.header__menu-item').removeClass('header__menu-item--active');
        }
      },

      setActiveClass() {
        $(document).on('click', '.header__menu-item', function() {
          $('.header__menu-item').filter('.header__menu-item--active').removeClass('header__menu-item--active');

          $(this).addClass('header__menu-item--active');
        });

        $(document).on('click', '.header__cart', function() {
          $('.header__menu-item').removeClass('header__menu-item--active');
        });
      },
    }

  }
</script>
